import React from 'react'
import { Box, Typography, Stack, Grid, InputLabel, TextareaAutosize, Select, MenuItem, FormHelperText } from '@mui/material'
import { Link, Route, Routes } from 'react-router'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ArrowForward } from '@mui/icons-material';
import FlowChart from './FlowChart';
import Navbar from '../Auth/Navbar';

function FormStateDesc() {
    return (
        <>
          <Navbar />
            <Stack sx={{ backgroundColor: "#eee", textAlign: "center", minHeight: "90vh", borderRadius: "6px" }} alignItems={"center"} justifyContent={"center"}>
                <Stack sx={{ backgroundColor: "#FFF", minHeight: "80vh", borderRadius: "6px", width: "85%", m: 4, p: 4 }}>
                    <Grid container justifyContent={"space-between"}>
                        <Grid item xs={2} >
                            <FlowChart index={3} />
                        </Grid>
                        <Grid item xs={8} sx={{ width: "75%" }} alignItems={"end"} justifyContent={"flex-end"}>
                            <Stack>
                                <Typography variant='h5' sx={{ fontWeight: "bold", p: 1, textAlign: "right", display: 'flex', flexDirection: "row-reverse" }} >
                                    <span>-3</span>
                                    وصف الحالة والدعم المطلوب
                                </Typography>
                                <form>
                                    <Grid container spacing={2} justifyContent={"end"}>
                                        <Grid item xs={6}>
                                            <Box mt={2}>
                                                <InputLabel>مستوى الضرر</InputLabel>
                                                <Select label="الضرر" fullWidth displayEmpty>
                                                    <MenuItem value=""><em>كبير</em></MenuItem>
                                                    {/* Add dynamic options here */}
                                                </Select>
                                            </Box>
                                            <Box mt={2}>
                                                <InputLabel>سبب الضرر</InputLabel>
                                                <Select label="الضرر" fullWidth displayEmpty>
                                                    <MenuItem value=""><em>حرب</em></MenuItem>
                                                    {/* Add dynamic options here */}
                                                </Select>
                                            </Box>

                                        </Grid>
                                        <Grid item xs={12} sx={{ minWidth: "100%" }}>


                                            <Box sx={{ width: "100%", textAlign: "right", my: 1 }}>
                                                <TextareaAutosize minRows={10} className='input' placeholder='اكتب وصف حالة العقار بما يخدم تقديم طلبك ويوضح حالته الفنية قدر الإمكان' />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={5} >
                                            <Box mt={2}>
                                                <InputLabel sx={{ my: 2 }}>نوع الدعم المطلوب</InputLabel>
                                                <Select label="الدعم" fullWidth displayEmpty>
                                                    <MenuItem value=""><em>مالي</em></MenuItem>
                                                    {/* Add dynamic options here */}
                                                </Select>
                                            </Box>

                                        </Grid>
                                    </Grid>
                                </form>
                            </Stack>
                        </Grid>

                        <Stack direction={"row"} justifyContent={"end"} alignItems={"center"} sx={{ width: "100%", gap: 2, my: 4 }}>
                            <Link to={"/InputDocuments"} className='btnLink' >
                                <ArrowBackIcon sx={{ mt: 1 }} />التالي
                            </Link>
                            <Link to="/InputInfoHouse" className='LinkbtnBack'>
                                رجوع
                                <ArrowForward sx={{ mt: 1 }} />
                            </Link>
                        </Stack>
                    </Grid>
                </Stack >
            </Stack >
        </>
    )
}


export default FormStateDesc